// Shared URL + naming helpers for the Film Clubs portal.
//
// CLUB IDENTITY: the showtimes.series field carries "Club" or
// "Club: Sub-series" ("Scream Scene: Macabre Mondays", "Bad Film Club:
// BIG & BAD") — the club is everything before the first colon. The same
// rule lives in the inject-seo edge function; keep them in sync.

export function eventUrlPath(id) {
  return `/film-clubs/${String(id).replace(/^popup-/, '')}`;
}

export function clubName(series) {
  if (!series) return null;
  return series.split(':')[0].trim();
}

export function clubSlug(series) {
  const name = clubName(series);
  if (!name) return null;
  return name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
}

export function clubUrlPath(series) {
  const slug = clubSlug(series);
  return slug ? `/film-clubs/club/${slug}` : '/film-clubs';
}

// Silent Clowns uses real cinema rows on both calendars; never duplicate a booking.
export const FILM_CLUB_FILTER = "cinema_id.eq.popup-events,series.eq.Silent Clowns Film Series";
